import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const {
    language,
    requestLanguageChange
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const toggleLanguage = () => {
    requestLanguageChange(language === 'en' ? 'es' : 'en');
  };
  const scrollToSection = (id: string) => {
    setIsOpen(false);
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        const navHeight = 80;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - navHeight,
          behavior: 'smooth'
        });
      }
    }, 350);
  };
  const menuItems = [{
    id: 'hero',
    en: 'Home',
    es: 'Inicio'
  }, {
    id: 'about',
    en: 'About',
    es: 'Sobre Mí'
  }, {
    id: 'portfolio',
    en: 'Portfolio',
    es: 'Portafolio'
  }, {
    id: 'credentials',
    en: 'Credentials',
    es: 'Credenciales'
  }, {
    id: 'specialty',
    en: 'Specialty',
    es: 'Especialidad'
  }, {
    id: 'process',
    en: 'Process',
    es: 'Proceso'
  }, {
    id: 'testimonials',
    en: 'Testimonials',
    es: 'Testimonios'
  }, {
    id: 'contact',
    en: 'Contact',
    es: 'Contacto'
  }];
  return <motion.nav className="fixed top-0 left-0 right-0 z-40 border-b border-brand-gold/30" style={{
    backgroundColor: '#000000'
  }} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    delay: 0.5
  }} data-id="element-82">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between relative" data-id="element-83">
        {/* Left side: Hamburger + Logo */}
        <div className="flex items-center gap-4 z-20 -ml-4 md:-ml-6" data-id="element-84">
          <button onClick={() => setIsOpen(!isOpen)} className="text-brand-gold hover:text-brand-white transition-colors p-2" aria-label="Toggle menu" data-id="element-85">
            {isOpen ? <X className="w-6 h-6" data-id="element-86" /> : <Menu className="w-6 h-6" data-id="element-87" />}
          </button>
          <img src="https://cdn.magicpatterns.com/uploads/8Qkd1gymRCWWEMH3tsQyqq/KGT_FONDO_NEGRO.png" alt="KRLY Gold Tattoo Logo" className="h-14 md:h-16 w-auto object-contain cursor-pointer" onClick={() => scrollToSection('hero')} data-id="element-88" />
        </div>

        {/* Centered text */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-10" data-id="element-89">
          <div className="font-serif text-brand-gold tracking-widest uppercase text-center leading-tight" data-id="element-90">
            <span className="block text-lg md:text-xl font-bold" data-id="element-91">
              KRLY GOLD
            </span>
            <span className="block text-sm md:text-base font-bold" data-id="element-92">TATTOO</span>
          </div>
        </div>

        {/* Right side: Language Toggle */}
        <div className="flex flex-col items-center z-20" data-id="element-93">
          <button onClick={() => requestLanguageChange('en')} className={`px-2 py-1 font-sans text-[10px] tracking-widest uppercase transition-all ${language === 'en' ? 'text-brand-gold font-bold' : 'text-brand-gold/40 hover:text-brand-gold/70'}`} data-id="element-94">
            EN
          </button>
          <div className="w-4 h-px bg-brand-gold/30" data-id="element-95" />
          <button onClick={() => requestLanguageChange('es')} className={`px-2 py-1 font-sans text-[10px] tracking-widest uppercase transition-all ${language === 'es' ? 'text-brand-gold font-bold' : 'text-brand-gold/40 hover:text-brand-gold/70'}`} data-id="element-96">
            ES
          </button>
        </div>
      </div>

      {/* Dropdown Menu */}
      <AnimatePresence data-id="element-97">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3
      }} className="absolute top-full left-0 right-0 bg-brand-black border-b border-brand-gold/30 overflow-hidden shadow-2xl" data-id="element-98">
            <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-99">
              <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6" data-id="element-100">
                {menuItems.map((item, index) => <motion.li key={item.id} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.05
            }} data-id="element-101">
                    <button onClick={() => scrollToSection(item.id)} className="text-brand-white/80 hover:text-brand-gold font-sans text-sm tracking-[0.2em] uppercase transition-colors w-full text-left py-2 border-b border-brand-gold/10 hover:border-brand-gold/50" data-id="element-102">
                      {language === 'en' ? item.en : item.es}
                    </button>
                  </motion.li>)}
              </ul>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}